class ModuleModule extends HTMLElement {
    connectedCallback() {
        this.load();
    }

    load() {
        // console.log(this);
    }
}

window.customElements.define("module-module", ModuleModule, {
    extends: "section",
});
